export default ({ request }) => ({
  amzExpenseItemListApi(data = {}) {
    return request({
      url: '/financial/amz/expense/item/list',
      method: 'POST',
      data,
    })
  },
})
